import { render, staticRenderFns } from "./SectionParagraph.vue?vue&type=template&id=b75946e6&"
import script from "./SectionParagraph.vue?vue&type=script&lang=js&"
export * from "./SectionParagraph.vue?vue&type=script&lang=js&"
import style0 from "./SectionParagraph.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow})
